<template>
  <el-row :gutter="50" class="no-m">
    <el-col :span="24" :xs="24">
      <el-form :model="form" ref="formProduct" status-icon label-width="110px" size="medium" class="form"
        label-position="top">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Código" prop="code" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
              <el-input :disabled="editing" type="text" v-model="form.code" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Referencia" prop="reference"
              :rules="[{ required: true, message: 'Campo Obligatorio' }]">
              <el-input type="text" v-model="form.reference" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="Descripción" prop="description"
              :rules="[{ required: true, message: 'Campo Obligatorio' }]">
              <el-input type="text" v-model="form.description" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Clave fiscal" prop="fiscal_key" >
              <el-input type="text" v-model="form.fiscal_key" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Código PEMEX" prop="pmex_code">
              <el-input type="text" v-model="form.pmex_code" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="Referencia del fabricante" prop="manufacturer_reference">
              <el-input type="text" v-model="form.manufacturer_reference" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="Descripción del fabricante" prop="manufacturer_description">
              <el-input type="text" v-model="form.manufacturer_description" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="9">
            <el-form-item label="Peso" prop="weight" >
              <el-input type="number" v-model="form.weight" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Largo" prop="length">
              <el-input type="number" v-model="form.length" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Ancho" prop="width">
              <el-input type="number" v-model="form.width" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="Alto" prop="height">
              <el-input type="number" v-model="form.height" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Costo" prop="coste" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
              <el-input type="number" v-model="form.coste" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Precio de venta" prop="priceSale"
              :rules="[{ required: true, message: 'Campo Obligatorio' }]">
              <el-input type="number" v-model="form.priceSale" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Categoría" prop="category" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
              <template slot="label">
                Categoría
                <el-popover v-model="showFormCategory" placement="right" width="400" trigger="click">
                  <form-category-component @success="setNewCategory"></form-category-component>
                  <el-button slot="reference" icon="el-icon-plus" size="mini" plain circle></el-button>
                </el-popover>
              </template>
              <el-select v-model="form.category" collapse-tags placeholder="Seleccione">
                <el-option v-for="item in categories" :key="item.id" :label="item.descripcion" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tipo" prop="type" :rules="[{ required: true, message: 'Campo Obligatorio' }]">
              <el-select v-model="form.type" :disabled="editing" collapse-tags placeholder="Seleccione">
                <el-option v-for="item in types" :key="item.id" :label="item.descripcion" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Unidad de medida" prop="measure">
              <el-select v-model="form.measure" placeholder="Seleccione">
                <el-option v-for="item in unitsMeasurements" :key="item.id" :label="item.measure_abbreviation" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type == 2">
          <el-col :span="24">
            <el-collapse v-model="activeNames">
              <el-collapse-item v-for="variation in form.variations" :key="variation.id"
                :title="variation.attribute.value_admin" name="all">
                <span>{{ variation.term.value_admin }}</span>
              </el-collapse-item>
            </el-collapse>
          </el-col>
        </el-row>
        <el-row v-if="form.type != 2" :gutter="10">
          <el-form-item label="Subir foto">
            <el-col :span="24">
              <el-upload action="#" ref="file" class="avatar-uploader" :show-file-list="false" :http-request="storeFile"
                :on-success="handleAvatarSuccess" :on-change="handleChange" :before-upload="beforeAvatarUpload"
                :multiple="false" :auto-upload="false">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
    </el-col>
    <transition name="slide-fade">
      <el-col :span="24" v-if="form.type == 2 && !editing">
        <attributes-component />
      </el-col>
    </transition>
  </el-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { edit, store, storeVariations, update, getUnitMeasurement } from '@/api/product'
import { getAllCategory } from '@/api/administration/category.js'
import { getAllType } from '@/api/administration/type.js'
import AttributesComponent from './Attributes.vue'
import FormCategoryComponent from '@/views/pages/administration/category/Form.vue'

export default {
  components: { AttributesComponent, FormCategoryComponent },
  data() {
    return {
      showFormCategory: false,
      activeNames: ['all'],
      tableData: [],
      loading: false,
      editing: false,
      categories: [],
      types: [],
      unitsMeasurements: [],
      width: 9,
      form: {
        id: null,
        code: '',
        reference: '',
        description: '',
        category: null,
        type: null,
        measure: null,
        coste: '',
        priceSale: '',
        image: '',
        manufacturer_reference: null,
        manufacturer_description: null,
        fiscal_key: null,
        pmex_code: null,
        weight: null,
        length: null,
        width: null,
        height: null,
      },
      imageUrl: '',
      imageRaw: null,
    };
  },
  computed: {
    ...mapGetters(['product'])
  },
  props: ['payload'],
  created() {
    let me = this
    if (me.payload.field_id)
      me.editProduct(me.payload.field_id)

    bus.$on("save", function (payload) {
      me.submitForm();
    });
    bus.$on("update", function (payload) {
      me.submitForm();
    });
    bus.$on("cancel", function (payload) {
      me.resetForm();
      bus.$emit("close");
    });
    me.getCategories()
    me.getTypes()
    me.getUnitsMeasurements()
  },
  methods: {
    ...mapMutations(['SET_RESPONSE', 'setRightMenuDrawer']),
    ...mapActions('product', ['getAllAction', 'deleteAction']),
    ...mapActions(['showErrors']),
    setNewCategory(value) {
      console.log(value);
      this.categories.push(value)
      this.form.category = value.id
      this.showFormCategory = false
    },
    async editProduct(id) {
      try {
        this.editing = true
        let data = await edit(id)
        let product = data.data
        console.log('asdf', product);
        this.form = {
          id: product.id,
          code: product.codigo,
          reference: product.referencia,
          description: product.descripcion,
          category: parseInt(product.categoria_id),
          type: parseInt(product.tipo_producto_id),
          coste: product.costo,
          priceSale: product.precio_venta,
          image: product.url_path,
          variations: product.variations,
          manufacturer_reference: product.manufacturer_reference,
          manufacturer_description: product.manufacturer_description,
          fiscal_key: (product.fiscal_key != "null") ? product.fiscal_key : "",
          pmex_code: (product.pmex_code != "null") ? product.pmex_code : "",
          weight: product.weight,
          length: product.length,
          width: product.width,
          height: product.height,
          measure: parseInt(product.unidad_medida_id),
        }
        this.imageUrl = product.url_path
      } catch (error) {
        console.log(error);
      }
    },
    async submitForm() {
      let formData = new FormData()
      Object.entries(this.form).forEach(([key, value]) => {
        formData.append(key, value);
      });
      if (this.imageRaw) {
        formData.append('file', this.imageRaw, this.imageRaw.name)
      }
      if (this.$refs['formProduct']) {
        this.$refs['formProduct'].validate((valid) => {
          if (valid) {
            if (this.editing) {
              this.updateForm(formData);
            } else {
              this.saveForm(formData);
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    async saveForm(formData) {
      try {
        if (!this.imageRaw) {
          formData.terms = this.product.terms
        }
        let data = null
        if (this.form.type == 2) {
          this.form.terms = this.product.terms
          data = await storeVariations(this.form)
        } else {
          data = await store(formData)
        }
        if (data.data.code === 200) {
          this.SET_RESPONSE({ type: 'success', msg: 'Producto guardado.' })
          this.getAllAction()
          this.setRightMenuDrawer(false)
        } else {
          this.SET_RESPONSE({ type: 'error', msg: 'Error al guardar.' })
        }
      } catch (error) {
        if (error.response.status == 422)
          this.showErrors(error.response.data.errors)
      }
    },
    async updateForm(formData) {
      try {
        let { data } = await update(formData)
        if (data.code === 200) {
          this.resetForm();
          this.getAllAction()
          this.setRightMenuDrawer(false)
        } else {
          this.$message.error("Error! " + data.error);
        }
      } catch (error) {
        if (error.response.status == 422)
          this.showErrors(error.response.data.errors)
      }
    },
    getAll() {
      bus.$emit('getAllProduct')
    },
    resetForm() {
      this.$refs['formProduct'].resetFields();
      this.form.id = "";
      this.imageRaw = null;
      this.imageUrl = null;
      this.editing = false;
    },
    getUnitsMeasurements() {
      getUnitMeasurement().then(({ data }) => {
        this.unitsMeasurements = data.data
      }).catch((error) => { console.log(error); })
    },
    getCategories() {
      getAllCategory().then(({ data }) => {
        this.categories = data
      }).catch((error) => { console.log(error); })
    },
    getTypes() {
      getAllType().then(({ data }) => {
        this.types = data
      }).catch((error) => { console.log(error); })
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    storeFile(file) {
      console.log('GUARDAR', file)
    },
    handleChange(file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.imageRaw = file.raw
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isSquare = file.heigth === file.width
      console.log('isSquare ', isSquare);
      if (!isJPG) {
        this.$message.error('La imagen debe estar en formato JPG!');
      }
      if (!isLt2M) {
        this.$message.error('La imagen excede los 2MB!');
      }
      this.imageUrl = file.url;
      return isJPG && isLt2M;
    }
  }
};
</script>
<style lang="scss" scope>
.el-form-item {
  margin-bottom: 10px;
}

/* Las animaciones de entrada y salida pueden usar */
/* funciones de espera y duración diferentes.      */
.slide-fade-enter-active {
  transition: all .3s ease;
}

// .slide-fade-leave-active {
//   transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
// }
.slide-fade-enter

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  height: 100px;
  display: block;
}
</style>

